export const msgTypeCharFieldsUpdate = "char.fields.update"
export const msgTypeCharModsAdd = "char.mods.add"
export const msgTypeCharModsUpdate = "char.mods.update"
export const msgTypeCharModsDelete = "char.mods.delete"
export const msgTypeIni = "ini"
export const msgTypeIniAdd = 'ini.add'
export const msgTypeIniClear = 'ini.clear'
export const msgTypeOnOpen = 'onopen'
export const msgTypeResultsAdd = 'results.add'
export const msgTypeResultsClear = 'results.clear'
export const msgTypeResults = 'results'
export const msgTypeCharAdd = "char.add"
export const msgTypeCharDelete = "char.delete"